import type {
  IProjectDetailItem,
  IProjectListItem,
  IProjectCollateralSubcategory,
  IProjectCollateralType,
} from '~/@api/generated-api-types-project/Api'
import type { ProjectCollateralCategory } from './projectCollateralCategory'

// Kľúč prekladateľného textu (title/shortDescription/...). Swagger typuje tieto polia
// ako string, runtime ale vracia raw objekt `{ sk, en, cs }` — konštanta drží kľúč `sk`
// (nahrádza ITranslatedText enum, ktorý vypadol z generovaných typov pri BE reorganizácii;
// const objekt namiesto enum kvôli tsconfig `erasableSyntaxOnly`).
export const ITranslatedText = {
  Sk: 'sk',
} as const
export type ITranslatedText =
  (typeof ITranslatedText)[keyof typeof ITranslatedText]

// Kolaterál „Iné (vlastný text)" — BO Meteor enum `ProjectCollateralType.OTHER`.
// Generovaný `IProjectCollateralType` ho zatiaľ nemá (Nest swagger enum neaktualizovaný),
// preto lokálna konštanta; runtime hodnota sedí s DB.
export const PROJECT_COLLATERAL_TYPE_OTHER = 'other'
export type ProjectCollateralType =
  | IProjectCollateralType
  | typeof PROJECT_COLLATERAL_TYPE_OTHER

// Vlastné HTML texty zabezpečenia (BO Froala). Ak sú vyplnené, zobrazia sa namiesto
// číselnej hodnoty / enum labelu. Detail vracia raw dokument, takže prídu aj bez regenu typov.
type CollateralCustomTexts = {
  collateralType?: ProjectCollateralType
  collateralTypeCustom?: string | null
  ltlPercentageCustom?: string | null
  propertyInfo?: {
    expertValueEstimateCustom?: string | null
    marketValueCustom?: string | null
  }
}

// BE typuje collateral kategórie ako plain string — FE ich zúži na enumy,
// runtime hodnoty sedia 1:1 (residential/commercial/... + subcategory).
type WithTypedCollateral<
  T extends {
    collateralInfo: {
      collateralCategory: string
      collateralSubcategory: string
    }
  },
> = Omit<T, 'collateralInfo'> & {
  collateralInfo: Omit<
    T['collateralInfo'],
    'collateralCategory' | 'collateralSubcategory' | 'collateralType'
  > & {
    collateralCategory: ProjectCollateralCategory
    collateralSubcategory: IProjectCollateralSubcategory
  } & CollateralCustomTexts
}

// Detail vracia celý raw project dokument vrátane paymentDates — netreba nič dopĺňať.
export type ProjectSchema = WithTypedCollateral<IProjectDetailItem>

type ProjectsItem = WithTypedCollateral<IProjectListItem>
type AppProjectPopupImageData = ProjectsItem['images']

export type { ProjectsItem, AppProjectPopupImageData }
